import { CaixaProps } from "../../components/Estrutura/Caixa";

export const espacos: CaixaProps[] = [
    {
    nome: "Espaço Social - Sala Técnica",
    descricao: "Espaço de convivência para alimentação, conversas, etc.",
    img: "/assets/Estudio/IMG_4368.jpg",
  },
  {
    nome: "Espaço Social - Sala B (1)",
    descricao: "Espaço de convivência para alimentação, conversas, etc.",
    img: "/assets/Estudio/IMG_8695.jpg",
  },
  {
    nome: "Espaço Social - Sala B (2)",
    descricao: "Espaço de convivência para alimentação, conversas, etc.",
    img: "/assets/Estudio/IMG_8697.jpg",
  },
  {
    nome: "Espaço Social - Sala B (2)",
    descricao: "Espaço de convivência para alimentação, conversas, etc.",
    img: "/assets/Estudio/IMG_8699.jpg",
  },
];